import { useEffect, useMemo } from 'react'
import { Box } from '@fe-toolkit/web-components'
import { useRouteError, useRouteLoaderData } from '@modern-js/runtime/router'
import { ThemeProvider, Typography } from '@fe-toolkit/web-components/ssr'
import { createLogger } from '@fe-toolkit/observability/client'

import type { MemberDetails } from '@/api/member/member.types'

const ErrorBoundary = () => {
  const error = useRouteError() as Response

  const layoutData = useRouteLoaderData('layout') as { memberDetails: MemberDetails } | undefined
  const memberId = layoutData?.memberDetails?.id?.toString() || undefined

  const logger = useMemo(() => createLogger({ name: 'ErrorBoundary', memberId }), [memberId])

  useEffect(() => {
    logger.error('Route error occurred', {
      status: error.status,
      statusText: error.statusText,
      url: window.location.href,
    })
  }, [error, logger])

  return (
    <ThemeProvider>
      <Box>
        <Typography as="h1" variant="speakUp">
          Oops! Something went wrong.
        </Typography>
        <Typography as="p">Status: {error.status}</Typography>
        <Typography as="p">{error.statusText}</Typography>
      </Box>
    </ThemeProvider>
  )
}

export default ErrorBoundary
